import type { CollectionPageResponse } from 'framework/ViewTypes/hooks';
import type { TaskConstructorListItem, TaskConstructorSearchParams } from './types';

// TODO: Replace search with the backend search endpoint when it is available.
const search = async ({
  pageNumber,
}: TaskConstructorSearchParams): Promise<CollectionPageResponse<TaskConstructorListItem>> => ({
  result: [],
  pageNumber,
  totalPages: 1,
  totalElements: 0,
});

const useTaskConstructorService = () => ({ search });

export default useTaskConstructorService;
